import React from "react";
import AddRemediationPolicy from "./FormsContainer";

function CreatePolicy(props) {
  return <AddRemediationPolicy key={props.location.pathname} />;
}

export default CreatePolicy;
